import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../pages/Home.css";

function SocialResponsability({ show, setShow }) {
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="justify-content-center text-header_modal align-items-center text-center pt-2 pb-2">
          <Modal.Title>
            Beba con moderación, es su responsabilidad
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
       
          <div className="text-dark p-2 size-text">
            El consumo excesivo de alcohol tiene efectos inmediatos que aumentan
            el riesgo de muchas consecuencias dañinas para la salud, incluyendo
            las siguientes:

            <p className="mt-2">
              - Lesiones, como por choques de vehículos automotores, caídas,
              ahogamientos y quemaduras.
            </p>
            <p>
              - Violencia, como homicidios, suicidios, agresión sexual y
              violencia doméstica con parejas sexuales.
            </p>
            <p className="pb-1">
              - Abortos espontáneos y muerte fetal o trastornos del espectro
              alcohólico fetal en las mujeres embarazadas y los bebés
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Link to="/" className="fs-5 d-flex align-items-center navbar-brand">
            <span className="logo_diferent text-dark">The </span>
            <span className="logo">Wine </span>
            <span className="logo_diferent text-dark">Cabinet</span>
          </Link>

          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SocialResponsability;

//   <div className="row m-0 bg-danger d-flex justify-content-center align-items-center text-center pt-5 pb-5">
//           <div>
//             <p className="pb-3" style={{ fontFamily: "Lobster Two, cursive", fontSize: "3rem" }}>
//               Beba con{" "}
//               <span style={{ color: "rgb(119, 33, 33)", fontWeight: "bolder" }}>moderación </span>,
//               <br />
//               es <span style={{ color: "rgb(119, 33, 33)", fontWeight: "bolder" }}>su </span>
//               responsabilidad.
//             </p>
//             <p className="pb-5" style={{ fontFamily: "Lobster Two, cursive", fontSize: "1.5rem" }}>
//               Si no lo hace por su bienestar, hágalo por el de aquellos que aún lo esperan en casa.
//             </p>
//           </div>

//           <div>
//             El consumo excesivo de alcohol tiene efectos inmediatos que aumentan el riesgo de muchas
//             consecuencias dañinas para la salud, incluyendo las siguientes:
//             <p>
//               - Lesiones, como por choques de vehículos automotores, caídas, ahogamientos y
//               quemaduras.
//             </p>
//             <p>
//               - Violencia, como homicidios, suicidios, agresión sexual y violencia doméstica con
//               parejas sexuales.
//             </p>
//             <p className="pb-3">
//               - Abortos espontáneos y muerte fetal o trastornos del espectro alcohólico fetal en las
//               mujeres embarazadas y los bebés
//             </p>
//           </div>
//         </div>
